import Carousel from "./Carousel"
import Card from './Card'
import Footer from './Footer'
import React, { useEffect, useState } from 'react'
import axios from "axios"

const url = "https://eightthsemnewfood.onrender.com"

function Home() {
  const [search, setsearch] = useState("")
  const [item, setitem] = useState([])
  const [category, setcategory] = useState([])

  useEffect(() => {
    axios.post(`${url}/item`).then((res) => {
      setitem(res.data)
    }).catch((err) => {
      setitem("not write at all may be right ")
    })

    axios.post(`${url}/catagory`).then((res) => {
      setcategory(res.data)
    }).catch((err) => {
      console.log("not write at all ")
    })
  }, [])


  return (
    <>
      <Carousel search={search} setsearch={setsearch} />
      {
  category.length > 0 ? category.map((elem) => (
    <div key={elem._id}>
      <h3 className="category-title">{elem.CategoryName}</h3>
      <hr />
      <div className="category-items">
        {
          item.filter((data) =>
            (data.CategoryName === elem.CategoryName) && data.name.toLowerCase().includes(search.toLowerCase())
          ).map((foodElem) => (
            <Card key={foodElem._id} fooditem={foodElem} options1={foodElem.options[0]} />
          ))
        }
      </div>
    </div>
  )) : <h2>No categories found</h2>
}
      
      <Footer />
    </>
  )
}

export default Home
